<template>
    <div class="has-background-grey-lighter has-text-centered login-process">
        <app-modal-view @close="logout" class="shareModal" v-if="showAgeModal">
        <template #header>
            <!--<div class="header-project">
                <img
                    src="@/assets/images/logo_eduloc360.png"
                    alt="eduloc360"
                    width="160"
                    height="50"
                />
                <p
                    aria-label="close"
                    class="lb-modal-close has-text-white is-pulled-right"
                    @click="$emit('close')"
                >
                    <span class="icon is-large">
                        <i class="mdi mdi-close mdi-24px"></i>
                    </span>
                </p>
            </div>-->
            <div class="header-project">
                <div class="navbar-menu">
                    <div class="navbar-start">
                        <router-link :to="'/'" class="navbar-item is-marginless">
                            <img
                                src="@/assets/images/logo_eduloc360.png"
                                alt="eduloc360"
                                width="160"
                                height="50"
                            />
                        </router-link>
                    </div>
                    <div class="navbar-end">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link is-arrowless">
                                <!--<span class="icon has-text-white"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                <span class="icon mr-1"><i class="mdi mdi-18px mdi-web"></i></span>
                                {{ $i18n.locale | localePrint }}
                            </a>
                            <div class="navbar-dropdown is-right">
                                <a
                                    v-for="locale in locales"
                                    :key="locale"
                                    @click="switchLocale(locale)"
                                    class="navbar-item has-text-black"
                                >
                                    {{ locale | localePrint }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #body>
            <p class="secondary-font pb-4 px-6" v-if="!$store.getters.hasMinimumAge">{{$t('confirm_age_intro')}}</p>
            <div class="columns is-mobile pt-1 mb-0 pr-0 is-centered" v-if="!$store.getters.hasMinimumAge">
                <div class="column is-7 pt-0 has-text-right">
                    <p class="pt-1">{{$t('confirm_age_text')}}</p>
                </div>
                <div class="column is-2 pt-0 has-text-left">
                    <span class="icon is-medium is-clickable" @click="toogleAgeConsent">
                        <i class="mdi mdi-32px"
                            :class="ageConsent ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                    </span>
                </div>
            </div>
            <div class="columns is-mobile pt-0 mb-0 pr-0 is-centered" v-if="!$store.getters.TOSAccepted">
                <div class="tos-desc column is-7 has-text-right pt-0">
                    <p class="pt-1" v-html="$t('confirm_tos_text')"/>
                </div>
                <div class="column is-2 pt-0 has-text-left">
                    <span class="icon is-medium is-clickable" @click="toogleTOS">
                        <i class="mdi mdi-32px"
                            :class="TOSaccepted ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                    </span>
                </div>
            </div>
            <!-- <div class="columns is-mobile pt-3 mb-0 pr-0 is-centered" v-if="$store.getters.personalData.invitation">
                <div class="column is-8 has-text-center pt-0">
                    <p class="pt-1">{{$t('entity_invitation_announcment')}} {{ $store.getters.personalData.invitation.entity }}</p>
                    <p class="pt-1">{{$t('entity_invitation_confirmation')}}</p>
                </div>
            </div>
            <div class="columns is-mobile pt-0 mb-0 pr-0 is-centered" v-if="$store.getters.personalData.invitation">
                <div class="column is-8 pt-0 has-text-center">
                    <div class="buttons has-addons is-centered pt-2">
                        <button class="button " :class="invitationConfirmed ? 'is-primary is-selected': ''" @click="confirmInvitation">{{$t('entity_invitation_confirm')}}</button>
                        <button class="button " :class="invitationdeclined ? 'is-primary is-selected': ''" @click="declineInvitation">{{$t('entity_invitation_decline')}}</button>
                    </div>
                    
                </div>
            </div>-->
            <div class="columns is-mobile pt-5 mb-0 pr-0 is-centered" >
                <div class="column is-narrow">
                    <button @click="updateProfile" class="button is-primary primary-font" :disabled="updateEnabled ? false : true">{{$t('confirm')}}</button>
                </div>
            </div>
        </template>
    </app-modal-view>
    </div>
</template>

<script>
import qs from 'qs';
import _ from 'underscore';
import { createItem } from '@/services/API';
import AppModalView from '@/components/AppModalView';
import Swal from 'sweetalert2';

export default {
    components: {
        AppModalView,
    },
    filters: {
        localePrint(locale) {
            return locale.slice(0, 2).toUpperCase();
        },
    },
    props: {
        code: { type: String, default: undefined },
        token: { type: String, default: undefined },
        idToken: { type: String, default: undefined },
        access_token: { type: String, default: undefined },
        lb: { type: String, default: undefined },
    },
    data() {
        return {
            showAgeModal: false,
            locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
            ageConsent: false,
            user: this.$store.getters.personalData,
            TOSaccepted: false,
            invitationConfirmed: false,
            invitationdeclined: false,
        };
    },
    watchs: {
        idToken: {
            handler: 'paramHandler',
            immediate: true,
        },
        code: {
            handler: 'paramHandler',
            immediate: true,
        },
    },
    mounted() {
        // console.log("login google")
        this.paramHandler();
    },
    computed: {
        updateEnabled() {
            /*if (this.$store.getters.personalData.invitation) {
                return this.ageConsent&&this.TOSaccepted&&(this.invitationConfirmed||this.invitationdeclined)
            } else {*/
                return this.ageConsent&&this.TOSaccepted
            //}
        },
    },
    methods: {
        paramHandler() {
            const query = qs.parse(
                qs.stringify(this.$route.query, { format: 'RFC1738' }),
                {
                    decoder: (c) => decodeURIComponent(c),
                }
            );
            // console.log('IN LOGIN', this.$store.getters.isLoggedIn);
            if (this.$store.getters.isLoggedIn) {
                this.$store.dispatch('logout');
            }
            
            this.$store
                .dispatch('login', { ...this.$route.params, ...query })
                .then(() => {
                    // console.log("IN LOGIN")
                    // console.log("has minimum age?", this.$store.getters.hasMinimumAge)
                    // console.log("invitation?",this.$store.getters.personalData.invitation)
                    if (this.$route.query.error) {
                        this.$store.dispatch('logout');
                        this.$router.push({
                            name: 'home_login',
                        });
                    }else if(!this.$store.getters.hasMinimumAge || !this.$store.getters.TOSAccepted || this.$store.getters.personalData.invitation ){
                        // console.log("Show confirm age modal");
                        if(this.$store.getters.hasMinimumAge){
                            this.ageConsent = this.$store.getters.hasMinimumAge;
                        }
                        if(this.$store.getters.TOSAccepted){
                            this.TOSaccepted = this.$store.getters.TOSAccepted;
                        }
                        this.showAgeModal=true;
                    }else{
                        // console.log("to enter plattform")
                        this.enterPlatform();
                    }
                })
                .catch((e) => {
                    Swal.fire({
                        title: this.$t('user_login_failed'),
                        html: this.$t(e.data),
                        confirmButtonText: this.$t('userProfile.leave_school_continue')
                    }).then((result) => {
                        this.$router.push({
                            name: 'home_login',
                        });
                    });

                    
                });
        },
        logout(){
            this.$store.dispatch('logout');
        },
        switchLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
            }
        },
        toogleAgeConsent(){
            this.ageConsent=!this.ageConsent;
        },
        toogleTOS(){
            this.TOSaccepted=!this.TOSaccepted;
        },
        updateProfile(){
            if(this.ageConsent && this.TOSaccepted){
                let userProfile = {...this.$store.getters.personalData};
                userProfile.hasMinimumAge = this.ageConsent;
                userProfile.TOSAccepted = this.TOSaccepted;
                // console.log(userProfile)
                if (this.invitationConfirmed) {
                    userProfile.invitationAccepted = true;
                } else if (this.invitationdeclined) {
                    userProfile.invitationDeclined = true;
                }
                this.$store.dispatch('updateProfile', userProfile).then((response) => {
                    // console.log("profile updated",response)
                    this.enterPlatform();
                }).catch(() => {
                    // console.log("in catch")
                    this.$router.push({
                        name: 'home_login',
                    });
                });
            }
        },
        enterPlatform() {
            // console.log("in enter plattform", this.$store.getters.personalData)
            if (this.$store.getters.personalData.school && this.$store.getters.personalData.school.email=="eduloc360@gmail.com") {
                Swal.fire({
                    html: this.$t('eduloc360_base_entity_alert'),
                    confirmButtonText: this.$t('userProfile.leave_school_continue')
                }).then((result) => {
                    /*this.$router.push({
                        name: 'home_login',
                    });*/
                });
            }
            if (null !== localStorage.getItem('currentUri')) {
                let currentUri = localStorage.getItem('currentUri');
                localStorage.removeItem('currentUri');
                if(currentUri!='/'){
                    this.$router.push({ path: currentUri });
                }else{
                    this.$router.push({
                        path: '/dashboard',
                        query: {
                            filter: 'mine',
                        },
                    });
                }
            } else {
                this.$router.push({
                    path: '/dashboard',
                    query: {
                        filter: 'mine',
                    },
                });
            }
        },
        confirmInvitation() {
            this.invitationConfirmed = true;
            this.invitationdeclined = false;
        },
        declineInvitation() {
            this.invitationConfirmed = false;
            this.invitationdeclined = true;
        }
    },
};
</script>

<style scoped>
    @import '../assets/css/project-modal-share.css';
    .login-process /deep/ .modal-card-head{
        background-color: var(--eduloc-red);
        padding-left: 20px !important;
        padding-right: 20px !important;
    }
    .login-process /deep/ .modal-card-body{
        padding: 20px !important;
    }
    .tos-desc /deep/ a{
        color: var(--eduloc-red);
    }
    .tos-desc /deep/ a:hover{
        color: var(--eduloc-red);
        text-decoration: underline;
    }
</style>
